import React, { useState } from "react";
import { saveCustomer } from "../../data/customers";

const NewClientModal = ({ show, onClose, onClientCreated }) => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    email: ""
  });

  if (!show) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.firstName || !formData.phone) return;
    
    const newClient = {
      id: `client-${Date.now()}`,
      ...formData,
      createdAt: new Date().toISOString()
    };
    
    try {
      await saveCustomer(newClient);
      onClientCreated(newClient);
      onClose();
    } catch (err) {
      console.error("Failed to save client", err);
    }
  };

  return (
    <div className="modal show d-block" style={{ backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1060 }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content shadow-lg border-0" style={{ backgroundColor: "#1f2937", color: "white", borderRadius: "12px" }}>
          <div className="modal-header border-secondary border-bottom-0 pt-4">
            <h5 className="modal-title fw-bold text-info"><i className="bi bi-person-plus-fill me-2"></i>Nouveau Client Rapide</h5>
            <button type="button" className="btn-close btn-close-white" onClick={onClose}></button>
          </div>
          <div className="modal-body px-4">
            <form id="newClientForm" onSubmit={handleSubmit}>
              <div className="row g-3 mb-3">
                <div className="col-6">
                  <label className="form-label small text-light opacity-75 fw-bold">PRÉNOM *</label>
                  <input type="text" className="form-control form-control-lg bg-dark text-white border-secondary" required value={formData.firstName} onChange={e => setFormData({...formData, firstName: e.target.value})} autoFocus />
                </div>
                <div className="col-6">
                  <label className="form-label small text-light opacity-75 fw-bold">NOM</label>
                  <input type="text" className="form-control form-control-lg bg-dark text-white border-secondary" value={formData.lastName} onChange={e => setFormData({...formData, lastName: e.target.value})} />
                </div>
              </div>
              <div className="mb-3">
                <label className="form-label small text-light opacity-75 fw-bold">TÉLÉPHONE *</label>
                <input type="tel" className="form-control form-control-lg bg-dark text-white border-secondary" required value={formData.phone} onChange={e => setFormData({...formData, phone: e.target.value})} placeholder="Ex: 06 12 34 56 78" />
              </div>
              <div className="mb-4">
                <label className="form-label small text-light opacity-75 fw-bold">EMAIL (Optionnel)</label>
                <input type="email" className="form-control bg-dark text-white border-secondary" value={formData.email} onChange={e => setFormData({...formData, email: e.target.value})} />
              </div>
            </form>
          </div>
          <div className="modal-footer border-secondary border-top-0 pb-4 px-4">
            <button type="button" className="btn btn-secondary fw-bold px-4" onClick={onClose}>ANNULER</button>
            <button type="submit" form="newClientForm" className="btn btn-info flex-grow-1 text-white fw-bold">
              CRÉER & SÉLECTIONNER
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default NewClientModal;

